import SingleOpportunity from './SingleOpportunity'

export default SingleOpportunity
